const HandleTypes = {
    findObjectType: (objectTypes, type) => objectTypes?.find((item) => item?.name === type),

    typeChange: (selected, target, setValue, objectTypes) => {
        const nextType = selected?.value ?? null;
        setValue(`${target}.type`, nextType);

        const targetType = HandleTypes.findObjectType(objectTypes, nextType);
        const hasSubtype = (targetType?.subTypes ?? []).length > 0;

        setValue(`${target}.subtype`, null);
        setValue(`${target}.unit`, null);

        if (nextType !== "Celular") {
            setValue(`${target}.imei`, null);
        }

        if (!hasSubtype && nextType) {
            setValue(`${target}.unit`, "UNITY");
        }
    },

    subtypeChange: (selected, target, setValue, objectTypes, type) => {
        const nextSubtype = selected?.value ?? null;
        setValue(`${target}.subtype`, nextSubtype);

        const targetType = HandleTypes.findObjectType(objectTypes, type);
        const hasSubtype = (targetType?.subTypes ?? []).length > 0;
        const currentSubtypeObj = (targetType?.subTypes ?? []).find(st => st?.name === nextSubtype);
        const stUnits = currentSubtypeObj?.units ?? [];

        setValue(`${target}.unit`, null);

        if (!nextSubtype && type && !hasSubtype) {
            setValue(`${target}.unit`, "UNITY");
        } else if (nextSubtype && stUnits.length === 1) {
            setValue(`${target}.unit`, stUnits[0]);
        }
    },

    imeiChange: (event, taget, setValue, getValues) => {
        const value = event?.target?.value;
        setValue(`${taget}.imei`, value);

        if (value) {
            setValue(`${taget}.quantity`, 1);
        } else {
            const currentQuantity = getValues(`${taget}.quantity`);
            if (currentQuantity === 1) setValue(`${taget}.quantity`, null);
        }
    }
}

export default HandleTypes;